export enum ProductSkeletonLengthEnum {
  Three = 3,
  Four = 4,
  Six = 6,
  Eight = 8,
}
